import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ArticleView } from '../components/help/article-view';
import { articleBySlug } from '../lib/help/articles';
import { useCustomArticles } from '../lib/help/custom';

export const Route = createFileRoute('/onboarding/$slug')({ component: ArticlePage });

function ArticlePage() {
  const { slug } = Route.useParams();
  const navigate = useNavigate();
  const article = articleBySlug(slug, useCustomArticles());

  // Jump to the section in the URL hash once the article has rendered.
  useEffect(() => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (id) document.getElementById(id)?.scrollIntoView({ block: 'start' });
  }, []);

  return (
    <div className="grid grid-cols-[minmax(0,1fr)_13rem] gap-8">
      <ArticleView slug={slug} onNavigate={(s, hash) => navigate({ to: '/onboarding/$slug', params: { slug: s }, hash })} />
      {article && article.headings.length > 1 && (
        <nav aria-label="On this page" className="sticky top-0 self-start text-sm">
          <h2 className="mb-2 text-xs font-semibold text-muted-foreground uppercase">On this page</h2>
          <ul className="space-y-1">
            {article.headings.map(h => (
              <li key={h.id} className={h.depth === 3 ? 'ps-3' : ''}>
                <a href={`#${h.id}`} className="text-muted-foreground hover:text-foreground">
                  {h.text}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
}
